import { Box, SxProps, Theme, useMediaQuery, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

const BackgroundCard = (
    props: PropsWithChildren<{ backgroundColorLight?: string; backgroundColorDark?: string; sx?: SxProps<Theme> | undefined }>
) => {
    const theme = useTheme();
    const isMobileDevice = useMediaQuery(theme.breakpoints.down('md'));
    const { backgroundColorLight = theme.palette.background.paper, backgroundColorDark = theme.palette.dark.dark, children, sx } = props;
    return (
        <Box
            sx={{
                background: theme.palette.mode === 'dark' ? backgroundColorDark : backgroundColorLight,
                borderRadius: 2,
                padding: isMobileDevice ? 1 : 2,
                ...sx
            }}
        >
            {children}
        </Box>
    );
};

export default BackgroundCard;
